import {NotFound} from "./not-found";

const errorPageRoutes = [{ path: "*", element: <NotFound /> }];

export default errorPageRoutes;
